"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { ReactNode } from "react";

interface ActiveLinkProps {
  href: string;
  className?: string;
  activeClassName?: string;
  nonActiveClassName?: string;
  children: ReactNode;
  onClick?: () => void;
}

export function ActiveLink({
  href,
  className = "",
  activeClassName = "",
  nonActiveClassName = "",
  children,
  onClick,
}: ActiveLinkProps) {
  const pathname = usePathname();
  const isActive = pathname === href;

  return (
    <Link
      href={href}
      onClick={onClick}
      className={`${className} ${isActive ? activeClassName : nonActiveClassName}`.trim()}
      aria-current={isActive ? "page" : undefined}
    >
      {children}
    </Link>
  );
}
